import "../assets/styles/Footer.css";

export default function Footer() {
  const goToPrivacy = () => {
    window.open("/privacy", "_blank");
  };
  const goToTerms = () => {
    window.open("/terms", "_blank");
  };
  const goToRefund = () => {
    window.open("/refund-policy", "_blank");
  };
  const goToPricing = () => {
    window.open("/pricing", "_blank");
  };
  const goToContactUs = () => {
    window.open("https://swaasa.ai/contact-us/", "_blank");
  };
  return (
    <div className="Footer no-printme">
      {/* <span className="Footer-text">Swaasa AI Platform v3.2</span>
      <span className="Footer-text">Health Check v4.2</span> */}
      <span className="Footer-links">
        <span className="Footer-text cp" onClick={goToContactUs}>
          Contact Us
        </span>
        <span className="Footer-text cp" onClick={goToPrivacy}>
          Privacy Policy
        </span>
        <span className="Footer-text cp" onClick={goToTerms}>
          Terms & Conditions
        </span>
        <span className="Footer-text cp" onClick={goToRefund}>
          Refund Policy
        </span>
        <span className="Footer-text cp" onClick={goToPricing}>
          Pricing
        </span>
      </span>
    </div>
  );
}
